// The chapters of the detective game, in play order (see Detective.js).
import * as chapter1 from './detectiveCase1';
import * as chapter2 from './detectiveCase2';
import * as chapter3 from './detectiveCase3';
import * as chapter4 from './detectiveCase4';
import * as chapter5 from './detectiveCase5';
import { LabFloorMap, MillSiteMap, PensionMap, NationMap, FinalMap } from './DetectiveMaps';

export const CHAPTERS = [
  { ...chapter1, Map: LabFloorMap },
  { ...chapter2, Map: MillSiteMap },
  { ...chapter3, Map: PensionMap },
  { ...chapter4, Map: NationMap },
  { ...chapter5, Map: FinalMap },
];

// Shown on the case list as "준비 중" until they are written. The series ends with chapter 5.
export const UPCOMING = [];
